import React, {Component} from 'react';
import Tour from 'reactour';
import { Trans } from 'react-i18next';

import LayoutAdvanced from '../components/LayoutAdvanced.jsx';
import NavigatorAdvanced from '../components/NavigatorAdvanced.jsx';
import Button from '../components/Button.jsx';
import Carousel from '../components/Carousel.jsx';

import Dialog from '@material-ui/core/Dialog';
import DialogButton from '@material-ui/core/Button';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import {createTheme} from '@material-ui/core/styles';
import {ThemeProvider} from '@material-ui/styles';

import {properties} from '../resources/properties.js';
import blackTheme from '../resources/blackThemeImages';
import i18n from '../resources/i18n';

import ImageEditor from 'tui-image-editor';

//...................................IMGS
//FOR FRONT MAP
import LOGO from '../img/Comunes/Logo_img01.png';//'../img/Comunes/img01.png'; //logo portada bot
import LOGO_MAC_N from '../img/Comunes/img02.png'; //logo MAC top
import LOGO_MAC_S_M from '../img/Comunes/img02_special_map.png'; //Logo MAC Especial MTN
import LOGO_MAC_S_I from '../img/Comunes/img02_special_img.png'; //Logo MAC Especial IMAGE
import DEGRADADO from '../img/Comunes/degradado.png'; //logo MAC top

// -----
import portada_GREEN from '../img/Fondos/img54.png';
import portada_PURPLE from '../img/Fondos/img55.png';
import portada_CYAN from '../img/Fondos/img53.png';
import portada_RED from '../img/Fondos/img52.png';
import portada_ORANGE from '../img/Fondos/img51.png';
import portada_BROWN from '../img/Fondos/img50.png';
import portada_GREY from '../img/Fondos/img49.png';
import portada_BLUE from '../img/Fondos/img48.png';

//AVENTURA
import IMG_AVENTURA_1 from '../img/Carousel/Aventura/img135.jpg';

import IMG_AVENTURA_2 from '../img/Carousel/Aventura/img136.jpg';
import IMG_AVENTURA_3 from '../img/Carousel/Aventura/img137.jpg';
import IMG_AVENTURA_4 from '../img/Carousel/Aventura/img138.jpg';
import IMG_AVENTURA_5 from '../img/Carousel/Aventura/img139.jpg';
import IMG_AVENTURA_6 from '../img/Carousel/Aventura/img140.jpg';
import IMG_AVENTURA_7 from '../img/Carousel/Aventura/img141.jpg';
import IMG_AVENTURA_8 from '../img/Carousel/Aventura/img142.jpg';
import IMG_AVENTURA_9 from '../img/Carousel/Aventura/img143.jpg';
import IMG_AVENTURA_10 from '../img/Carousel/Aventura/img144.jpg';
import IMG_AVENTURA_11 from '../img/Carousel/Aventura/img145.jpg';
import IMG_AVENTURA_12 from '../img/Carousel/Aventura/img146.jpg';
import IMG_AVENTURA_13 from '../img/Carousel/Aventura/img147.jpg';
import IMG_AVENTURA_14 from '../img/Carousel/Aventura/img148.jpg';
import IMG_AVENTURA_15 from '../img/Carousel/Aventura/img149.jpg';
import IMG_AVENTURA_16 from '../img/Carousel/Aventura/img150.jpg';
import IMG_AVENTURA_17 from '../img/Carousel/Aventura/img151.jpg';
import IMG_AVENTURA_18 from '../img/Carousel/Aventura/img152.jpg';
//CARTOGRAFIA
import IMG_CARTOGRAFIA_1 from '../img/Carousel/Cartografia/img153.jpg';
import IMG_CARTOGRAFIA_2 from '../img/Carousel/Cartografia/img154.jpg';
import IMG_CARTOGRAFIA_3 from '../img/Carousel/Cartografia/img155.jpg';
import IMG_CARTOGRAFIA_4 from '../img/Carousel/Cartografia/img156.jpg';
import IMG_CARTOGRAFIA_5 from '../img/Carousel/Cartografia/img157.jpg';
import IMG_CARTOGRAFIA_6 from '../img/Carousel/Cartografia/img158.jpg';
import IMG_CARTOGRAFIA_7 from '../img/Carousel/Cartografia/img159.jpg';
import IMG_CARTOGRAFIA_8 from '../img/Carousel/Cartografia/img160.jpg';
//CIUDADES
import IMG_CIUDADES_1 from '../img/Carousel/Ciudades/img161.jpg';
import IMG_CIUDADES_2 from '../img/Carousel/Ciudades/img162.jpg';
import IMG_CIUDADES_3 from '../img/Carousel/Ciudades/img163.jpg';
import IMG_CIUDADES_5 from '../img/Carousel/Ciudades/img165.jpg';
import IMG_CIUDADES_6 from '../img/Carousel/Ciudades/img166.jpg';
import IMG_CIUDADES_7 from '../img/Carousel/Ciudades/img167.jpg';
import IMG_CIUDADES_8 from '../img/Carousel/Ciudades/img168.jpg';
import IMG_CIUDADES_9 from '../img/Carousel/Ciudades/img169.jpg';
import IMG_CIUDADES_10 from '../img/Carousel/Ciudades/img170.jpg';
import IMG_CIUDADES_11 from '../img/Carousel/Ciudades/img171.jpg';

//NATURALEZA
import IMG_NATURALEZA_1 from '../img/Carousel/Naturaleza/img172.jpg';
import IMG_NATURALEZA_2 from '../img/Carousel/Naturaleza/img173.jpg';
import IMG_NATURALEZA_3 from '../img/Carousel/Naturaleza/img174.jpg';
import IMG_NATURALEZA_4 from '../img/Carousel/Naturaleza/img175.jpg';
import IMG_NATURALEZA_5 from '../img/Carousel/Naturaleza/img176.jpg';

//PAISAJES
import IMG_PAISAJES_1 from '../img/Carousel/Paisajes/img177.jpg';
import IMG_PAISAJES_2 from '../img/Carousel/Paisajes/img178.jpg';
import IMG_PAISAJES_3 from '../img/Carousel/Paisajes/img179.jpg';
import IMG_PAISAJES_4 from '../img/Carousel/Paisajes/img180.jpg';
import IMG_PAISAJES_5 from '../img/Carousel/Paisajes/img181.jpg';
import IMG_PAISAJES_6 from '../img/Carousel/Paisajes/img182.jpg';
import IMG_PAISAJES_7 from '../img/Carousel/Paisajes/img183.jpg';
import IMG_PAISAJES_8 from '../img/Carousel/Paisajes/img184.jpg';
import IMG_PAISAJES_9 from '../img/Carousel/Paisajes/img185.jpg';

//VARIOS
import IMG_VARIOS_1 from '../img/Carousel/Varios/img186.jpg';
import IMG_VARIOS_2 from '../img/Carousel/Varios/img187.jpg';
import IMG_VARIOS_3 from '../img/Carousel/Varios/img188.jpg';
import IMG_VARIOS_4 from '../img/Carousel/Varios/img189.jpg';
import IMG_VARIOS_5 from '../img/Carousel/Varios/img190.jpg';
import IMG_VARIOS_6 from '../img/Carousel/Varios/img191.jpg';
import IMG_VARIOS_7 from '../img/Carousel/Varios/img192.jpg';
import IMG_VARIOS_8 from '../img/Carousel/Varios/img193.jpg';
import IMG_VARIOS_9 from '../img/Carousel/Varios/img194.jpg';
import IMG_VARIOS_10 from '../img/Carousel/Varios/img195.jpg';
import IMG_VARIOS_11 from '../img/Carousel/Varios/img196.jpg';

//...................................IMGS MAPPED
//AVENTURA
import IMG_AVENTURA_1_MAPPED from '../img/Carousel/Aventura/img73.jpg';
import IMG_AVENTURA_2_MAPPED from '../img/Carousel/Aventura/img74.jpg';
import IMG_AVENTURA_3_MAPPED from '../img/Carousel/Aventura/img75.jpg';
import IMG_AVENTURA_4_MAPPED from '../img/Carousel/Aventura/img76.jpg';
import IMG_AVENTURA_5_MAPPED from '../img/Carousel/Aventura/img77.jpg';
import IMG_AVENTURA_6_MAPPED from '../img/Carousel/Aventura/img78.jpg';
import IMG_AVENTURA_7_MAPPED from '../img/Carousel/Aventura/img79.jpg';
import IMG_AVENTURA_8_MAPPED from '../img/Carousel/Aventura/img80.jpg';
import IMG_AVENTURA_9_MAPPED from '../img/Carousel/Aventura/img81.jpg';
import IMG_AVENTURA_10_MAPPED from '../img/Carousel/Aventura/img82.jpg';
import IMG_AVENTURA_11_MAPPED from '../img/Carousel/Aventura/img83.jpg';
import IMG_AVENTURA_12_MAPPED from '../img/Carousel/Aventura/img84.jpg';
import IMG_AVENTURA_13_MAPPED from '../img/Carousel/Aventura/img85.jpg';
import IMG_AVENTURA_14_MAPPED from '../img/Carousel/Aventura/img86.jpg';
import IMG_AVENTURA_15_MAPPED from '../img/Carousel/Aventura/img87.jpg';
import IMG_AVENTURA_16_MAPPED from '../img/Carousel/Aventura/img88.jpg';
import IMG_AVENTURA_17_MAPPED from '../img/Carousel/Aventura/img89.jpg';
import IMG_AVENTURA_18_MAPPED from '../img/Carousel/Aventura/img90.jpg';
//CARTOGRAFIA
import IMG_CARTOGRAFIA_1_MAPPED from '../img/Carousel/Cartografia/img91.jpg';
import IMG_CARTOGRAFIA_2_MAPPED from '../img/Carousel/Cartografia/img92.jpg';
import IMG_CARTOGRAFIA_3_MAPPED from '../img/Carousel/Cartografia/img93.jpg';
import IMG_CARTOGRAFIA_4_MAPPED from '../img/Carousel/Cartografia/img94.jpg';
import IMG_CARTOGRAFIA_5_MAPPED from '../img/Carousel/Cartografia/img95.jpg';
import IMG_CARTOGRAFIA_6_MAPPED from '../img/Carousel/Cartografia/img96.jpg';
import IMG_CARTOGRAFIA_7_MAPPED from '../img/Carousel/Cartografia/img97.jpg';
import IMG_CARTOGRAFIA_8_MAPPED from '../img/Carousel/Cartografia/img98.jpg';

//CIUDADES
import IMG_CIUDADES_1_MAPPED from '../img/Carousel/Ciudades/img99.jpg';
import IMG_CIUDADES_2_MAPPED from '../img/Carousel/Ciudades/img100.jpg';
import IMG_CIUDADES_3_MAPPED from '../img/Carousel/Ciudades/img101.jpg';
import IMG_CIUDADES_5_MAPPED from '../img/Carousel/Ciudades/img103.jpg';
import IMG_CIUDADES_6_MAPPED from '../img/Carousel/Ciudades/img104.jpg';
import IMG_CIUDADES_7_MAPPED from '../img/Carousel/Ciudades/img105.jpg';
import IMG_CIUDADES_8_MAPPED from '../img/Carousel/Ciudades/img106.jpg';
import IMG_CIUDADES_9_MAPPED from '../img/Carousel/Ciudades/img107.jpg';
import IMG_CIUDADES_10_MAPPED from '../img/Carousel/Ciudades/img108.jpg';
import IMG_CIUDADES_11_MAPPED from '../img/Carousel/Ciudades/img109.jpg';

//NATURALEZA
import IMG_NATURALEZA_1_MAPPED from '../img/Carousel/Naturaleza/img110.jpg';
import IMG_NATURALEZA_2_MAPPED from '../img/Carousel/Naturaleza/img111.jpg';
import IMG_NATURALEZA_3_MAPPED from '../img/Carousel/Naturaleza/img112.jpg';
import IMG_NATURALEZA_4_MAPPED from '../img/Carousel/Naturaleza/img113.jpg';
import IMG_NATURALEZA_5_MAPPED from '../img/Carousel/Naturaleza/img114.jpg';

//PAISAJES
import IMG_PAISAJES_1_MAPPED from '../img/Carousel/Paisajes/img115.jpg';
import IMG_PAISAJES_2_MAPPED from '../img/Carousel/Paisajes/img116.jpg';
import IMG_PAISAJES_3_MAPPED from '../img/Carousel/Paisajes/img117.jpg';
import IMG_PAISAJES_4_MAPPED from '../img/Carousel/Paisajes/img118.jpg';
import IMG_PAISAJES_5_MAPPED from '../img/Carousel/Paisajes/img119.jpg';
import IMG_PAISAJES_6_MAPPED from '../img/Carousel/Paisajes/img120.jpg';
import IMG_PAISAJES_7_MAPPED from '../img/Carousel/Paisajes/img121.jpg';
import IMG_PAISAJES_8_MAPPED from '../img/Carousel/Paisajes/img122.jpg';
import IMG_PAISAJES_9_MAPPED from '../img/Carousel/Paisajes/img123.jpg';

//VARIOS
import IMG_VARIOS_1_MAPPED from '../img/Carousel/Varios/img124.jpg';
import IMG_VARIOS_2_MAPPED from '../img/Carousel/Varios/img125.jpg';
import IMG_VARIOS_3_MAPPED from '../img/Carousel/Varios/img126.jpg';
import IMG_VARIOS_4_MAPPED from '../img/Carousel/Varios/img127.jpg';
import IMG_VARIOS_5_MAPPED from '../img/Carousel/Varios/img128.jpg';
import IMG_VARIOS_6_MAPPED from '../img/Carousel/Varios/img129.jpg';
import IMG_VARIOS_7_MAPPED from '../img/Carousel/Varios/img130.jpg';
import IMG_VARIOS_8_MAPPED from '../img/Carousel/Varios/img131.jpg';
import IMG_VARIOS_9_MAPPED from '../img/Carousel/Varios/img132.jpg';
import IMG_VARIOS_10_MAPPED from '../img/Carousel/Varios/img133.jpg';
import IMG_VARIOS_11_MAPPED from '../img/Carousel/Varios/img134.jpg';

//AVENTURA_R
import IMG_AVENTURA_1_MAPPED_R from '../img/Carousel/Aventura/img73_R.jpg';
import IMG_AVENTURA_2_MAPPED_R from '../img/Carousel/Aventura/img74_R.jpg';
import IMG_AVENTURA_3_MAPPED_R from '../img/Carousel/Aventura/img75_R.jpg';
import IMG_AVENTURA_4_MAPPED_R from '../img/Carousel/Aventura/img76_R.jpg';
import IMG_AVENTURA_5_MAPPED_R from '../img/Carousel/Aventura/img77_R.jpg';
import IMG_AVENTURA_6_MAPPED_R from '../img/Carousel/Aventura/img78_R.jpg';
import IMG_AVENTURA_7_MAPPED_R from '../img/Carousel/Aventura/img79_R.jpg';
import IMG_AVENTURA_8_MAPPED_R from '../img/Carousel/Aventura/img80_R.jpg';
import IMG_AVENTURA_9_MAPPED_R from '../img/Carousel/Aventura/img81_R.jpg';
import IMG_AVENTURA_10_MAPPED_R from '../img/Carousel/Aventura/img82_R.jpg';
import IMG_AVENTURA_11_MAPPED_R from '../img/Carousel/Aventura/img83_R.jpg';
import IMG_AVENTURA_12_MAPPED_R from '../img/Carousel/Aventura/img84_R.jpg';
import IMG_AVENTURA_13_MAPPED_R from '../img/Carousel/Aventura/img85_R.jpg';
import IMG_AVENTURA_14_MAPPED_R from '../img/Carousel/Aventura/img86_R.jpg';
import IMG_AVENTURA_15_MAPPED_R from '../img/Carousel/Aventura/img87_R.jpg';
import IMG_AVENTURA_16_MAPPED_R from '../img/Carousel/Aventura/img88_R.jpg';
import IMG_AVENTURA_17_MAPPED_R from '../img/Carousel/Aventura/img89_R.jpg';
import IMG_AVENTURA_18_MAPPED_R from '../img/Carousel/Aventura/img90_R.jpg';
//CARTOGRAFIA_R
import IMG_CARTOGRAFIA_1_MAPPED_R from '../img/Carousel/Cartografia/img91_R.jpg';
import IMG_CARTOGRAFIA_2_MAPPED_R from '../img/Carousel/Cartografia/img92_R.jpg';
import IMG_CARTOGRAFIA_3_MAPPED_R from '../img/Carousel/Cartografia/img93_R.jpg';
import IMG_CARTOGRAFIA_4_MAPPED_R from '../img/Carousel/Cartografia/img94_R.jpg';
import IMG_CARTOGRAFIA_5_MAPPED_R from '../img/Carousel/Cartografia/img95_R.jpg';
import IMG_CARTOGRAFIA_6_MAPPED_R from '../img/Carousel/Cartografia/img96_R.jpg';
import IMG_CARTOGRAFIA_7_MAPPED_R from '../img/Carousel/Cartografia/img97_R.jpg';
import IMG_CARTOGRAFIA_8_MAPPED_R from '../img/Carousel/Cartografia/img98_R.jpg';
//CIUDADES_R
import IMG_CIUDADES_1_MAPPED_R from '../img/Carousel/Ciudades/img99_R.jpg';
import IMG_CIUDADES_2_MAPPED_R from '../img/Carousel/Ciudades/img100_R.jpg';
import IMG_CIUDADES_3_MAPPED_R from '../img/Carousel/Ciudades/img101_R.jpg';
import IMG_CIUDADES_5_MAPPED_R from '../img/Carousel/Ciudades/img103_R.jpg';
import IMG_CIUDADES_6_MAPPED_R from '../img/Carousel/Ciudades/img104_R.jpg';
import IMG_CIUDADES_7_MAPPED_R from '../img/Carousel/Ciudades/img105_R.jpg';
import IMG_CIUDADES_8_MAPPED_R from '../img/Carousel/Ciudades/img106_R.jpg';
import IMG_CIUDADES_9_MAPPED_R from '../img/Carousel/Ciudades/img107_R.jpg';
import IMG_CIUDADES_10_MAPPED_R from '../img/Carousel/Ciudades/img108_R.jpg';
import IMG_CIUDADES_11_MAPPED_R from '../img/Carousel/Ciudades/img109_R.jpg';
//NATURALEZA_R
import IMG_NATURALEZA_1_MAPPED_R from '../img/Carousel/Naturaleza/img110_R.jpg';
import IMG_NATURALEZA_2_MAPPED_R from '../img/Carousel/Naturaleza/img111_R.jpg';
import IMG_NATURALEZA_3_MAPPED_R from '../img/Carousel/Naturaleza/img112_R.jpg';
import IMG_NATURALEZA_4_MAPPED_R from '../img/Carousel/Naturaleza/img113_R.jpg';
import IMG_NATURALEZA_5_MAPPED_R from '../img/Carousel/Naturaleza/img114_R.jpg';
//PAISAJES_R
import IMG_PAISAJES_1_MAPPED_R from '../img/Carousel/Paisajes/img115_R.jpg';
import IMG_PAISAJES_2_MAPPED_R from '../img/Carousel/Paisajes/img116_R.jpg';
import IMG_PAISAJES_3_MAPPED_R from '../img/Carousel/Paisajes/img117_R.jpg';
import IMG_PAISAJES_4_MAPPED_R from '../img/Carousel/Paisajes/img118_R.jpg';
import IMG_PAISAJES_5_MAPPED_R from '../img/Carousel/Paisajes/img119_R.jpg';
import IMG_PAISAJES_6_MAPPED_R from '../img/Carousel/Paisajes/img120_R.jpg';
import IMG_PAISAJES_7_MAPPED_R from '../img/Carousel/Paisajes/img121_R.jpg';
import IMG_PAISAJES_8_MAPPED_R from '../img/Carousel/Paisajes/img122_R.jpg';
import IMG_PAISAJES_9_MAPPED_R from '../img/Carousel/Paisajes/img123_R.jpg';
//VARIOS_R
import IMG_VARIOS_1_MAPPED_R from '../img/Carousel/Varios/img124_R.jpg';
import IMG_VARIOS_2_MAPPED_R from '../img/Carousel/Varios/img125_R.jpg';
import IMG_VARIOS_3_MAPPED_R from '../img/Carousel/Varios/img126_R.jpg';
import IMG_VARIOS_4_MAPPED_R from '../img/Carousel/Varios/img127_R.jpg';
import IMG_VARIOS_5_MAPPED_R from '../img/Carousel/Varios/img128_R.jpg';
import IMG_VARIOS_6_MAPPED_R from '../img/Carousel/Varios/img129_R.jpg';
import IMG_VARIOS_7_MAPPED_R from '../img/Carousel/Varios/img130_R.jpg';
import IMG_VARIOS_8_MAPPED_R from '../img/Carousel/Varios/img131_R.jpg';
import IMG_VARIOS_9_MAPPED_R from '../img/Carousel/Varios/img132_R.jpg';
import IMG_VARIOS_10_MAPPED_R from '../img/Carousel/Varios/img133_R.jpg';
import IMG_VARIOS_11_MAPPED_R from '../img/Carousel/Varios/img134_R.jpg';

const sizeImageCustomUnit = (properties.MAX_POST_SIZE / 1048576 >= 1)
  ? (Math.round(properties.MAX_POST_SIZE / 1048576) + ' MB')
  : (Math.round(properties.MAX_POST_SIZE / 1024) + ' KB');

const theme = createTheme({
  palette: { primary: { 500: properties.BUTTON_THEME_COLOR } },
  overrides: { MuiButton: { containedPrimary: { color: 'white' } } }
});
const themeTitle = createTheme({
  palette: { primary: { 500: properties.TITLE_THEME_COLOR } },
  overrides: { MuiDialogTitle: { root: { backgroundColor: properties.TITLE_THEME_COLOR, color: 'white' } } }
});

class Step2 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      showModalCustomImage: false,
      isTourOpen: false
    };
    this.handleClose = this.handleClose.bind(this);
    this.handleShow = this.handleShow.bind(this);
    this.handleCloseCustomImage = this.handleCloseCustomImage.bind(this);
    this.handleShowCustomImage = this.handleShowCustomImage.bind(this);
    if(props.parentState.verticalCartela && (props.parentState.seleccionadoProductoSeries === 'Elaborado') && props.parentState.imageName === 'img91.jpg'){ //(props.parentState.active < 6)
      props.parentState.imageName = 'img91_R.jpg';
    }
    this.blockColor = true;
    this.showSpan = true;
    this.rotateBarcode = this.props.parentState.verticalCartela;//Special_landscape_R: Special_report_R.jrxml //Special_portrait_R: Special_reportNewPortrait_R.jrxml
    if (this.props.parentState.specialMapGeneration) {
      if(this.rotateBarcode && this.props.parentState.codigoBarras){
        this.saveVerticalBarCode();
      } else {
        this.props.parentState.realCodigoBarras = this.props.parentState.codigoBarras;
      }
      if(props.parentState.seleccionadoProductoSeries === 'Foto'){
        this.LOGO_MAC = LOGO_MAC_S_I;
      }else{
        this.LOGO_MAC = LOGO_MAC_S_M;
      }
    } else {
      this.LOGO_MAC = LOGO_MAC_N;//Logos WEB apropiados segun Mapa Especial
    }
  }

  handleClose() {
    this.setState({showModal: false});
  }

  handleShow() {
    this.setState({showModal: true});
  }

  handleCloseCustomImage() {
    this.setState({showModalCustomImage: false});
  }

  handleShowCustomImage() {
    this.setState({showModalCustomImage: true});
  }

  setStateGlobal = (parentState) => {
    const {setParentState} = this.props;

    setParentState(parentState);
  }
  setStateGlobalStep = (state) => {
    const {setParentStateSteps} = this.props;
    setParentStateSteps(state);
  }

  setFrontImg = (option) => {
    let {parentState} = this.props;
    let imageName = option.split('/');
    imageName = imageName[imageName.length - 1].split('.');
    imageName = imageName[0] + (!imageName[0].endsWith('_R') && parentState.verticalCartela && parentState.seleccionadoProductoSeries === 'Elaborado'?'_R.':'.') + imageName[imageName.length - 1];//parentState.active < 6
    parentState.imageName = imageName;
    parentState.image = option;
    parentState.imageRotatedForVertical = null;//clear
    document.getElementById('tui-image-editor').style = 'display: none;';
    document.getElementById('download-tui-image').style = 'display: none;';
    this.setStateGlobal(parentState);
  }

  setText = (event) => {
    let {parentState} = this.props;
    switch (event.target.name) {
      case 'textTitle':
        parentState.title = event.target.value;
        break;
      case 'textSubtitle':
        parentState.subtitle = event.target.value;
        break;
      case 'textAuthor':
        if (!parentState.specialMapGeneration) {
          parentState.author = event.target.value;
        }
        break;
//Mapa Especial
      case 'textNipo':
        parentState.nipo = event.target.value;
        break;
      case 'textISBN':
        parentState.isbn = event.target.value;
        break;
      case 'textDepositoLegal':
        parentState.depositoLegal = event.target.value;
        break;
//Mapa Especial
      default:
        parentState.title = event.target.value;
    }
    this.setStateGlobal(parentState);
  }

  setActiveColor = (event) => {
    let {parentState} = this.props;

    switch (event.target.name) {
      case 'portada_BLUE':
        parentState.color = '#184962';
        parentState.portada = portada_BLUE;
        break;
      case 'portada_RED':
        parentState.color = '#952616';
        parentState.portada = portada_RED;
        break;
      case 'portada_ORANGE':
        parentState.color = '#f7a941';
        parentState.portada = portada_ORANGE;
        break;
      case 'portada_GREEN':
        parentState.color = '#00a75d';
        parentState.portada = portada_GREEN;
        break;
      case 'portada_GREY':
        parentState.color = '#858584';
        parentState.portada = portada_GREY;
        break;
      case 'portada_BROWN':
        parentState.color = '#946a43';
        parentState.portada = portada_BROWN;
        break;
      case 'portada_CYAN':
        parentState.color = '#5db3ae';
        parentState.portada = portada_CYAN;
        break;
      case 'portada_PURPLE':
        parentState.color = '#985fa4';
        parentState.portada = portada_PURPLE;
        break;
      default:
        parentState.color = '#184962';
        parentState.portada = portada_BLUE;
    }
    this.setStateGlobal(parentState);
  }

  handleChangeImage = (event) => {
    let {parentState} = this.props;
    let reader = new FileReader();
    let file = event.target.files[0];
    if (file.size > properties.MAX_POST_SIZE) {
      event.target.value = null;
      this.handleShow();
      return;
    }
    let img = new Image();
    reader.onload = (upload) => {
      img.src = upload.target.result;
      //parentState.image = upload.target.result;
    };
    img.onload = () => {
      var oc = document.createElement('canvas'),
      octx = oc.getContext('2d');
      oc.width = img.width;
      oc.height = img.height;
      octx.drawImage(img, 0, 0, oc.width, oc.height);
      parentState.image = oc.toDataURL();
      this.openImageEditor(parentState.image);
      if(parentState.verticalCartela){
        this.saveTemporalVertical();
      }
    }
    reader.readAsDataURL(file);
  }

  handleChangeImageBarras = (event) => {
    let {parentState} = this.props;
    let reader = new FileReader();
    let file = event.target.files[0];
    if (file.size > properties.MAX_POST_SIZE) {
      event.target.value = null;
      this.handleShow();
      return;
    }
    parentState.specialFileName = file.name;
    let img = new Image();
    reader.onload = (upload) => {
      if(this.rotateBarcode){
        this.saveVerticalBarCode(upload.target.result);
      }
      img.src = upload.target.result;
    };
    img.onload = () => {
      this.blockColor = false;
      this.showSpan = false;
      var oc = document.createElement('canvas'),
      octx = oc.getContext('2d');
      oc.width = img.width;
      oc.height = img.height;
      octx.drawImage(img, 0, 0, oc.width, oc.height);
      parentState.codigoBarras = oc.toDataURL();
      if(!this.rotateBarcode){
        parentState.realCodigoBarras = parentState.codigoBarras;
      }
      this.setState({});
    }
    reader.readAsDataURL(file);
  }

  clearCodigoBarras = (event) => {
    let {parentState} = this.props;
    this.blockColor = true;
    this.showSpan = true;
    event.target.parentElement.childNodes[0].value = null;
    event.target.parentElement.childNodes[0].files = null;
    parentState.codigoBarras = null;
    parentState.realCodigoBarras = null;
    parentState.specialFileName = null;
    this.setState({});
  }

  saveVerticalBarCode(url){
    let {parentState} = this.props;
    let imgVertical = new Image();
    imgVertical.src = url || parentState.codigoBarras;
    imgVertical.onload = () => {
      var ocVertical = document.createElement('canvas'),
      octxVertical = ocVertical.getContext('2d');
      ocVertical.width = imgVertical.height;
      ocVertical.height = imgVertical.width;
      ocVertical.style.position = "absolute";
      octxVertical.translate(imgVertical.height / 2, imgVertical.width / 2);
      octxVertical.rotate(Math.PI / 2);
      octxVertical.translate(-imgVertical.width / 2, -imgVertical.height / 2);
      octxVertical.drawImage(imgVertical, 0, 0, ocVertical.height, ocVertical.width);
      parentState.realCodigoBarras = ocVertical.toDataURL();
    }
  }

  setNullValue() {
    document.getElementById('file-upload').value = null;

  }
  setActiveTab = (event) => {
    let {parentState} = this.props;
    switch (event.target.name) {
      case 'cartografia':
        parentState.carouselTabActive = "cartografia";
        break;
      case 'ciudades':
        parentState.carouselTabActive = "ciudades";
        break;
      case 'naturaleza':
        parentState.carouselTabActive = "naturaleza";
        break;
      case 'paisaje':
        parentState.carouselTabActive = "paisaje";
        break;
      case 'varios':
        parentState.carouselTabActive = "varios";
        break;
      default:
        parentState.carouselTabActive = "aventura";
        break;

    }
    this.setStateGlobal(parentState);
  }

  setTitle = (event) => {
    let {parentState} = this.props;
    if (event.target.value === '') {
      parentState.title = event.target.placeholder;
    } else {
      parentState.title = event.target.value;
    }
    this.setStateGlobal(parentState);
  }
  setSubtitle = (event) => {
    let {parentState} = this.props;
    parentState.subtitle = event.target.value;
    this.setStateGlobal(parentState);
  }

  saveTemporalVertical(){// similar a rotateBase64Image, pero sin nombrado de "custom" y girado en otra dirreción
    let {parentState} = this.props;
    let imgVertical = new Image();
    imgVertical.src = parentState.image;
    imgVertical.onload = () => {
      var ocVertical = document.createElement('canvas'),
      octxVertical = ocVertical.getContext('2d');
      ocVertical.width = imgVertical.height;
      ocVertical.height = imgVertical.width;
      ocVertical.style.position = "absolute";
      octxVertical.translate(imgVertical.height / 2, imgVertical.width / 2);
      octxVertical.rotate(Math.PI / 2);
      octxVertical.translate(-imgVertical.width / 2, -imgVertical.height / 2);
      octxVertical.drawImage(imgVertical, 0, 0, ocVertical.height, ocVertical.width);
      parentState.imageRotatedForVertical = ocVertical.toDataURL();
      parentState.imageName = 'custom';
    }
  }

  openImageEditor = (imageData) => {
    let {parentState} = this.props;
    const imageEditor = new ImageEditor(document.querySelector('#tui-image-editor'), {
      includeUI: {
        loadImage: {
          path: imageData,
          name: 'SampleImage',
        },
        theme: blackTheme,
        //initMenu: 'filter',//filter not present in menu:['crop', 'rotate', 'flip', 'resize']
        menuBarPosition: 'right',
        menu: ['crop', 'rotate', 'flip', 'resize'],
      },
      cssMaxWidth: 700,
      cssMaxHeight: 400,
      selectionStyle: {
        cornerSize: 20,
        rotatingPointOffset: 70,
      },
    });
    window.imageEditor = undefined;

    document.getElementById('tui-image-editor').style = 'height: 550px;';
    document.getElementsByClassName('tui-image-editor-header-logo')[0].style = 'display:none';
    const applyButton = document.getElementById('download-tui-image');
    applyButton.style = 'display: inline-block;';
    this.handleCloseCustomImage();
    for (const element of document.getElementsByClassName('tui-image-editor-download-btn')){
      element.style = 'display:none';
    }
    applyButton.removeEventListener('click', this.temporalApplyEvent);
    this.temporalApplyEvent = () => {
      parentState.image = window.imageEditor.toDataURL();
      if(parentState.verticalCartela){
        this.saveTemporalVertical();
      }
      this.rotateBase64Image(parentState);
    };
    this.extraCropzoneApplyEvent = () => {
      if(window.imageEditor._graphics._componentMap.CROPPER._cropzone.isValid()){
        setTimeout(this.temporalApplyEvent, 10);
      }
    };
    applyButton.addEventListener('click', this.temporalApplyEvent);
    if (window.imageEditor === undefined){
      document.querySelectorAll('.tie-btn-crop:not(.active)')[0].onclick = () => {
        let interval;
        document.getElementsByClassName('tie-crop-preset-button')[0].style = 'display:none;';
        document.getElementsByClassName('tui-image-editor-partition only-left-right')[0].style = 'display:none;';
        document.getElementsByClassName('tie-crop-button action')[0].style = 'margin-top:0px;';
        const rationCustomImage = (parentState.verticalCartela ? properties.RATIO_CUSTOM_IMAGE_VERTICAL : properties.RATIO_CUSTOM_IMAGE).split(':').reduce((a, b) => a / b);
        window.imageEditor.ui.crop._els.apply.removeEventListener('click', this.extraCropzoneApplyEvent);
        window.imageEditor.ui.crop._els.apply.addEventListener('click', this.extraCropzoneApplyEvent);
        const cropFunction = () => {
          if (document.getElementsByClassName('tie-btn-crop tui-image-editor-item normal active').length > 0 && document.getElementsByClassName('tie-crop-preset-button').length > 0) {
            window.imageEditor.setCropzoneRect(rationCustomImage);
            clearInterval(interval);
          }
          if (document.getElementsByClassName('tui-image-editor-main tui-image-editor-menu-crop').length === 0 && document.getElementsByClassName('tie-btn-crop tui-image-editor-item normal active').length === 0) {
            clearInterval(interval);
          }
        }
        interval = setInterval( cropFunction, 100);
      }
    }
    window.imageEditor = imageEditor;
    setTimeout(this.temporalApplyEvent, 200);
  }

  setAuthor = (event) => {
    let {parentState} = this.props;
    parentState.author = event.target.value;
    this.setStateGlobal(parentState);
  }

  rotateBase64Image = (parentState) => {
    var image = new Image();
    image.src = parentState.image;
    image.onload = () => {
      //var canvas = document.createElement("canvas");canvas.height = image.width;canvas.width = image.height;canvas.style.position = "absolute";var ctx = canvas.getContext("2d");ctx.translate(image.height / 2, image.width / 2);ctx.rotate(-Math.PI / 2);ctx.translate(-image.width / 2, -image.height / 2);ctx.drawImage(image, 0, 0);parentState.imgCustomPortrait = canvas.toDataURL();//Si no me equivoco esto no se usa
      parentState.imageName = 'custom';
      this.setStateGlobal(parentState);
      this.handleCloseCustomImage();
    };

  }

  closeTour = () => {
    this.setState({isTourOpen: false});
  }

  openTour = () => {
    this.setState({isTourOpen: true});
  }

  render() {
    const scaleValue = this.props.scale;
    const activeRow = this.props.activeRow;
    const coordenadas = this.props.coordenadas;
    const allowedFormatsCustomImage = properties.FORMATOS_PERMITIDOS_IMAGEN;

    const ratioCustomImage = this.props.parentState.verticalCartela? properties.RATIO_CUSTOM_IMAGE_VERTICAL : properties.RATIO_CUSTOM_IMAGE;
    const isTourOpen = this.state.isTourOpen;
    const steps = [
      {
        selector: '.bg-color',
        content: i18n.t('tour.step2FirstStep'),
      },
      {
        selector: '.textsStep2',
        content: this.props.parentState.specialMapGeneration ? i18n.t('tour.specialStep2') : i18n.t('tour.step1Or2Parameters'),
      },
      {
        selector: '.step2wizardPanel3',
        content: i18n.t('tour.step2ThirdStep'),
      },
      {
        selector: '.tabs',
        content: i18n.t('tour.step2FourthStep'),
      },
      {
        selector: '.div-img',
        content: i18n.t('tour.step2FifthStep'),
      }
    ]

    //Left navigator
    const leftFirstDivClassName = 'wizard-1';
    const leftSecondDivClassName = 'circle bg-active';
    const leftTextSecondDivClassName = 'mc-design mc-2x';
    const leftLabelClassNameTittle = 'step-name active';
    const leftLabelTextTittle = i18n.t('step1.leftLabelTextTittle');
    const leftLabelClassNameDescription = 'step-description';
    const leftLabelDescription = i18n.t('step1.leftLabelDescription');
    const leftBarClassName = 'bar bg-active';

    //Center navigator
    const centerFirstDivClassName = 'wizard-2';
    const centerSecondDivClassName = 'circle bg-active';
    const centerTextSecondDivClassName = 'mc-map mc-2x';
    const centerLabelClassNameTittle = 'step-name active';
    const centerLabelTextTittle = i18n.t('step1.centerLabelTextTittle');
    const centerLabelClassNameDescription = 'step-description';
    const centerLabelDescription = i18n.t('step1.centerLabelDescription');
    const rightBarClassName = 'bar';

    //Right navigator
    const rightFirstDivClassName = 'wizard-3';
    const rightSecondDivClassName = 'circle';
    const rightTextSecondDivClassName = 'mc-pin-check mc-2x';
    const rightLabelClassNameTittle = 'step-name';
    const rightLabelTextTittle = i18n.t('step1.rightLabelTextTittle');
    const rightLabelClassNameDescription = 'step-description';
    const rightLabelDescription = i18n.t('step1.rightLabelDescription');

    //StepBody
    const stepClassName = this.props.parentState.verticalCartela? 'step2 cartelaRetrato':'step2';
    const sectionClassName = 's2-left-b';
    const asideClassName = 's2-right';

    //Next and previous pages
    const nextPage = "/Step2";
    const previousPage = "/Step1";
    //Aventura
    const imgsAventura = [
      IMG_AVENTURA_1,
      IMG_AVENTURA_2,
      IMG_AVENTURA_3,
      IMG_AVENTURA_4,
      IMG_AVENTURA_5,
      IMG_AVENTURA_6,
      IMG_AVENTURA_7,
      IMG_AVENTURA_8,
      IMG_AVENTURA_9,
      IMG_AVENTURA_10,
      IMG_AVENTURA_11,
      IMG_AVENTURA_12,
      IMG_AVENTURA_13,
      IMG_AVENTURA_14,
      IMG_AVENTURA_15,
      IMG_AVENTURA_16,
      IMG_AVENTURA_17,
      IMG_AVENTURA_18
    ];
    const imgsAventuraMapped = [[
      IMG_AVENTURA_1_MAPPED,
      IMG_AVENTURA_2_MAPPED,
      IMG_AVENTURA_3_MAPPED,
      IMG_AVENTURA_4_MAPPED,
      IMG_AVENTURA_5_MAPPED,
      IMG_AVENTURA_6_MAPPED,
      IMG_AVENTURA_7_MAPPED,
      IMG_AVENTURA_8_MAPPED,
      IMG_AVENTURA_9_MAPPED,
      IMG_AVENTURA_10_MAPPED,
      IMG_AVENTURA_11_MAPPED,
      IMG_AVENTURA_12_MAPPED,
      IMG_AVENTURA_13_MAPPED,
      IMG_AVENTURA_14_MAPPED,
      IMG_AVENTURA_15_MAPPED,
      IMG_AVENTURA_16_MAPPED,
      IMG_AVENTURA_17_MAPPED,
      IMG_AVENTURA_18_MAPPED
    ],[
      IMG_AVENTURA_1_MAPPED_R,
      IMG_AVENTURA_2_MAPPED_R,
      IMG_AVENTURA_3_MAPPED_R,
      IMG_AVENTURA_4_MAPPED_R,
      IMG_AVENTURA_5_MAPPED_R,
      IMG_AVENTURA_6_MAPPED_R,
      IMG_AVENTURA_7_MAPPED_R,
      IMG_AVENTURA_8_MAPPED_R,
      IMG_AVENTURA_9_MAPPED_R,
      IMG_AVENTURA_10_MAPPED_R,
      IMG_AVENTURA_11_MAPPED_R,
      IMG_AVENTURA_12_MAPPED_R,
      IMG_AVENTURA_13_MAPPED_R,
      IMG_AVENTURA_14_MAPPED_R,
      IMG_AVENTURA_15_MAPPED_R,
      IMG_AVENTURA_16_MAPPED_R,
      IMG_AVENTURA_17_MAPPED_R,
      IMG_AVENTURA_18_MAPPED_R
    ]];

    //Cartografía

    const imgsCartografia = [
      IMG_CARTOGRAFIA_1,
      IMG_CARTOGRAFIA_2,
      IMG_CARTOGRAFIA_3,
      IMG_CARTOGRAFIA_4,
      IMG_CARTOGRAFIA_5,
      IMG_CARTOGRAFIA_6,
      IMG_CARTOGRAFIA_7,
      IMG_CARTOGRAFIA_8
    ];
    const imgsCartografiaMapped = [[
      IMG_CARTOGRAFIA_1_MAPPED,
      IMG_CARTOGRAFIA_2_MAPPED,
      IMG_CARTOGRAFIA_3_MAPPED,
      IMG_CARTOGRAFIA_4_MAPPED,
      IMG_CARTOGRAFIA_5_MAPPED,
      IMG_CARTOGRAFIA_6_MAPPED,
      IMG_CARTOGRAFIA_7_MAPPED,
      IMG_CARTOGRAFIA_8_MAPPED
    ],[
      IMG_CARTOGRAFIA_1_MAPPED_R,
      IMG_CARTOGRAFIA_2_MAPPED_R,
      IMG_CARTOGRAFIA_3_MAPPED_R,
      IMG_CARTOGRAFIA_4_MAPPED_R,
      IMG_CARTOGRAFIA_5_MAPPED_R,
      IMG_CARTOGRAFIA_6_MAPPED_R,
      IMG_CARTOGRAFIA_7_MAPPED_R,
      IMG_CARTOGRAFIA_8_MAPPED_R
    ]];

    //Ciudades

    const imgsCiudades = [
      IMG_CIUDADES_1,
      IMG_CIUDADES_2,
      IMG_CIUDADES_3,
      IMG_CIUDADES_5,
      IMG_CIUDADES_6,
      IMG_CIUDADES_7,
      IMG_CIUDADES_8,
      IMG_CIUDADES_9,
      IMG_CIUDADES_10,
      IMG_CIUDADES_11
    ];
    const imgsCiudadesMapped = [[
      IMG_CIUDADES_1_MAPPED,
      IMG_CIUDADES_2_MAPPED,
      IMG_CIUDADES_3_MAPPED,
      IMG_CIUDADES_5_MAPPED,
      IMG_CIUDADES_6_MAPPED,
      IMG_CIUDADES_7_MAPPED,
      IMG_CIUDADES_8_MAPPED,
      IMG_CIUDADES_9_MAPPED,
      IMG_CIUDADES_10_MAPPED,
      IMG_CIUDADES_11_MAPPED
    ],[
      IMG_CIUDADES_1_MAPPED_R,
      IMG_CIUDADES_2_MAPPED_R,
      IMG_CIUDADES_3_MAPPED_R,
      IMG_CIUDADES_5_MAPPED_R,
      IMG_CIUDADES_6_MAPPED_R,
      IMG_CIUDADES_7_MAPPED_R,
      IMG_CIUDADES_8_MAPPED_R,
      IMG_CIUDADES_9_MAPPED_R,
      IMG_CIUDADES_10_MAPPED_R,
      IMG_CIUDADES_11_MAPPED_R
    ]];

    //Naturaleza

    const imgsNaturaleza = [IMG_NATURALEZA_1, IMG_NATURALEZA_2, IMG_NATURALEZA_3, IMG_NATURALEZA_4, IMG_NATURALEZA_5];
    const imgsNaturalezaMapped = [[IMG_NATURALEZA_1_MAPPED, IMG_NATURALEZA_2_MAPPED, IMG_NATURALEZA_3_MAPPED, IMG_NATURALEZA_4_MAPPED, IMG_NATURALEZA_5_MAPPED],
    [IMG_NATURALEZA_1_MAPPED_R, IMG_NATURALEZA_2_MAPPED_R, IMG_NATURALEZA_3_MAPPED_R, IMG_NATURALEZA_4_MAPPED_R, IMG_NATURALEZA_5_MAPPED_R]];

    //Paisaje

    const imgsPaisaje = [
      IMG_PAISAJES_1,
      IMG_PAISAJES_2,
      IMG_PAISAJES_3,
      IMG_PAISAJES_4,
      IMG_PAISAJES_5,
      IMG_PAISAJES_6,
      IMG_PAISAJES_7,
      IMG_PAISAJES_8,
      IMG_PAISAJES_9
    ];
    const imgsPaisajeMapped = [[
      IMG_PAISAJES_1_MAPPED,
      IMG_PAISAJES_2_MAPPED,
      IMG_PAISAJES_3_MAPPED,
      IMG_PAISAJES_4_MAPPED,
      IMG_PAISAJES_5_MAPPED,
      IMG_PAISAJES_6_MAPPED,
      IMG_PAISAJES_7_MAPPED,
      IMG_PAISAJES_8_MAPPED,
      IMG_PAISAJES_9_MAPPED
    ],[
      IMG_PAISAJES_1_MAPPED_R,
      IMG_PAISAJES_2_MAPPED_R,
      IMG_PAISAJES_3_MAPPED_R,
      IMG_PAISAJES_4_MAPPED_R,
      IMG_PAISAJES_5_MAPPED_R,
      IMG_PAISAJES_6_MAPPED_R,
      IMG_PAISAJES_7_MAPPED_R,
      IMG_PAISAJES_8_MAPPED_R,
      IMG_PAISAJES_9_MAPPED_R
    ]];
    //Varios
    const imgsVarios = [
      IMG_VARIOS_1,
      IMG_VARIOS_2,
      IMG_VARIOS_3,
      IMG_VARIOS_4,
      IMG_VARIOS_5,
      IMG_VARIOS_6,
      IMG_VARIOS_7,
      IMG_VARIOS_8,
      IMG_VARIOS_9,
      IMG_VARIOS_10,
      IMG_VARIOS_11
    ];
    const imgsVariosMapped = [[
      IMG_VARIOS_1_MAPPED,
      IMG_VARIOS_2_MAPPED,
      IMG_VARIOS_3_MAPPED,
      IMG_VARIOS_4_MAPPED,
      IMG_VARIOS_5_MAPPED,
      IMG_VARIOS_6_MAPPED,
      IMG_VARIOS_7_MAPPED,
      IMG_VARIOS_8_MAPPED,
      IMG_VARIOS_9_MAPPED,
      IMG_VARIOS_10_MAPPED,
      IMG_VARIOS_11_MAPPED
    ],[
      IMG_VARIOS_1_MAPPED_R,
      IMG_VARIOS_2_MAPPED_R,
      IMG_VARIOS_3_MAPPED_R,
      IMG_VARIOS_4_MAPPED_R,
      IMG_VARIOS_5_MAPPED_R,
      IMG_VARIOS_6_MAPPED_R,
      IMG_VARIOS_7_MAPPED_R,
      IMG_VARIOS_8_MAPPED_R,
      IMG_VARIOS_9_MAPPED_R,
      IMG_VARIOS_10_MAPPED_R,
      IMG_VARIOS_11_MAPPED_R
    ]];

    const {label, parentState} = this.props;
    let placeholderFile;
    if(parentState){
      placeholderFile = (parentState.codigoBarras? (parentState.specialFileName?parentState.specialFileName:i18n.t('step2.selectedFile')) :i18n.t('step2.notSelectedFile')) || (parentState.codigoBarras ? 'Archivo previamente seleccionado.' : 'Archivo no seleccionado.');
    } else {
      placeholderFile = parentState.codigoBarras ? (parentState.specialFileName?parentState.specialFileName:'Archivo previamente seleccionado.') : 'Archivo no seleccionado.';
    }

    return (<React.Fragment>
      <LayoutAdvanced setParentStateSteps={this.setStateGlobal} parentState={parentState} label={label} nextPage={nextPage} previousPage={previousPage} stated={scaleValue} activeRow={activeRow} coordenadas={coordenadas} isStep3={0}>
        <Dialog open={this.state.showModal} onClose={this.handleClose} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
          <ThemeProvider theme={themeTitle}>
            <DialogTitle color="primary" id="alert-dialog-title">
            <Trans i18nKey="dialog.uploadImage">
              Subir Imagen
            </Trans>
            </DialogTitle>
          </ThemeProvider>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
            <Trans i18nKey="dialog.errorHeavyFile">
              La imagen que ha seleccionado excede el tamaño límite establecido</Trans> ({sizeImageCustomUnit})
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <ThemeProvider theme={theme}>
              <DialogButton size="small" variant="contained" color="primary" onClick={this.handleClose}>
              <Trans i18nKey="dialog.back">
                Volver
              </Trans>
              </DialogButton>
            </ThemeProvider>
          </DialogActions>
        </Dialog>

        <Dialog open={this.state.showModalCustomImage} onClose={this.handleCloseCustomImage} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
          <ThemeProvider theme={themeTitle}>
            <DialogTitle color="primary" id="alert-dialog-title">
            <Trans i18nKey="dialog.uploadImage">
              Subir Imagen
            </Trans>
            </DialogTitle>
          </ThemeProvider>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              <Trans i18nKey="dialog.allowedFormats">Los formatos permitidos son</Trans> {allowedFormatsCustomImage}.<br/>
              <Trans i18nKey="dialog.maxFileSize">El tamaño máximo de la imagen es de</Trans> {sizeImageCustomUnit}<br/>
              <Trans i18nKey="dialog.bestResoultImage">Para un resultado óptimo, la imagen debe tener una proporción</Trans> {ratioCustomImage}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <ThemeProvider theme={theme}>
              <DialogButton size="small" variant="contained" color="primary" onClick={this.setNullValue}>
                <label htmlFor="file-upload" id="inputFileDialogButton" style={{
                    width: '100%',
                    cursor: 'pointer'
                  }}>
                  <i className="mc-upload"></i>
                  <Trans i18nKey="dialog.uploadImageUpperCase">
                  SUBIR IMAGEN
                  </Trans>
                </label>
              </DialogButton>
            </ThemeProvider>
            <ThemeProvider theme={theme}>
              <DialogButton size="small" variant="contained" color="primary" onClick={this.handleCloseCustomImage}>
              <Trans i18nKey="dialog.cancel">
                CANCELAR
              </Trans>
              </DialogButton>
            </ThemeProvider>
          </DialogActions>
        </Dialog>

        <NavigatorAdvanced leftFirstDivClassName={leftFirstDivClassName} leftSecondDivClassName={leftSecondDivClassName} leftTextSecondDivClassName={leftTextSecondDivClassName} leftLabelClassNameTittle={leftLabelClassNameTittle} leftLabelTextTittle={leftLabelTextTittle} leftLabelClassNameDescription={leftLabelClassNameDescription} leftLabelDescription={leftLabelDescription} centerFirstDivClassName={centerFirstDivClassName} centerSecondDivClassName={centerSecondDivClassName} centerTextSecondDivClassName={centerTextSecondDivClassName} centerLabelClassNameTittle={centerLabelClassNameTittle} centerLabelTextTittle={centerLabelTextTittle} centerLabelClassNameDescription={centerLabelClassNameDescription} centerLabelDescription={centerLabelDescription} rightFirstDivClassName={rightFirstDivClassName} rightSecondDivClassName={rightSecondDivClassName} rightTextSecondDivClassName={rightTextSecondDivClassName} rightLabelClassNameTittle={rightLabelClassNameTittle} rightLabelTextTittle={rightLabelTextTittle} rightLabelClassNameDescription={rightLabelClassNameDescription} rightLabelDescription={rightLabelDescription} leftBarClassName={leftBarClassName} rightBarClassName={rightBarClassName} parentState={parentState} setParentStateSteps={this.setStateGlobalStep}></NavigatorAdvanced>
        <Tour
          steps={steps}
          isOpen={isTourOpen}
          onRequestClose={this.closeTour} />
        <h1>
          <i className="mc-map"></i>
          <label>
          <Trans i18nKey="step2.coverDesign">
            Diseño de la portada
          </Trans>
          </label>
        </h1>
        <div className={stepClassName}>
          <aside className={sectionClassName}>
            <figure>
              <div className="div-img">
                <div style={{ display: parentState.verticalCartela?'none':'block', height: '15px', marginLeft: '30px', marginTop: '-10px', backgroundColor: parentState.color }}></div>
                <div className="svgRetrato" style={{ display: parentState.verticalCartela?'block':'none'}}><svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="100%" height="100%" viewBox="0 0 736 313">
                  <path d="M0 0 736 0l0 313-184 0 0-213L30 37l0 276-30 0Z" fill={parentState.color}></path>
                  <rect x="18" y="0" width="240" height="88" strokeWidth="0" fill="#ffffff"></rect>
                </svg></div>
                <img style={{ display: parentState.verticalCartela?'none':'block'}} alt="Not found" src={parentState.portada}></img>
                <img alt="Not found" className="logo-bot" src={LOGO}></img>
                <img alt="Not found" className="logo-top" src={this.LOGO_MAC}></img>
                <img alt="Not found" className="degradado" src={DEGRADADO}></img>
                <p className="front-scale-container">{parentState.scale}</p>

                <p className="front-scale-container-cm">{parentState.scaleCm}</p>
                <p className="front-scale-container-1cm">(1cm ➝</p>
                {/* Title */}
                <p className='front-title-container'>
                  {parentState.title}
                </p>
                {/* Subtitle */}
                <p className='front-subtitle-container'>
                  {parentState.subtitle}
                </p>
                {/* Author */}
                <p className='front-author-container'>
                  {parentState.author}
                </p>
                <div className='img-front-div'>
                  <img className='img-front' src={parentState.image} alt='Img not found'/>
                </div>
              </div>
            </figure>
            { /* eslint-disable-next-line */}
            <a onClick={this.openTour}>
              <label id="tourButton" className="inputfile step2wizardPanelHelpButton">
                <Trans i18nKey="wizardPanel.help">Ayuda</Trans>
              </label>
            </a>
          </aside>
          <section className={asideClassName}>
            <div className="color-flag">
              <div className="bg-color">
                {/* COLOR SELECTOR */}
                <label>
                  <Trans i18nKey="step2.background">
                    Fondo
                  </Trans>
                </label>
                <Button name="portada_BLUE" buttonClass={parentState.color === '#184962'
                    ? 'bg-blue active'
                    : 'bg-blue'} onClick={this.setActiveColor}></Button>
                <Button name="portada_RED" buttonClass={parentState.color === '#952616'
                    ? 'bg-red active'
                    : 'bg-red'} onClick={this.setActiveColor}></Button>
                <Button name="portada_ORANGE" buttonClass={parentState.color === '#f7a941'
                    ? 'bg-orange active'
                    : 'bg-orange'} onClick={this.setActiveColor}></Button >
                <Button name="portada_GREEN" buttonClass={parentState.color === '#00a75d'
                    ? 'bg-green active'
                    : 'bg-green'} onClick={this.setActiveColor}></Button>
                <Button name="portada_GREY" buttonClass={parentState.color === '#858584'
                    ? 'bg-grey active'
                    : 'bg-grey'} onClick={this.setActiveColor}></Button >
                <Button name="portada_BROWN" buttonClass={parentState.color === '#946a43'
                    ? 'bg-brown active'
                    : 'bg-brown'} onClick={this.setActiveColor}></Button>
                <Button name="portada_CYAN" buttonClass={parentState.color === '#5db3ae'
                    ? 'bg-cyan active'
                    : 'bg-cyan'} onClick={this.setActiveColor}></Button >
                <Button name="portada_PURPLE" buttonClass={parentState.color === '#985fa4'
                    ? 'bg-purple active'
                    : 'bg-purple'} onClick={this.setActiveColor}></Button>

              </div>

            </div>
            {/* TEXT */}
            <h2 className="h2Custom"><Trans i18nKey="step2.texts">Textos</Trans></h2>
            <div className="textsStep2">
              <div className="texts-row">
                <div className="texts">
                  <input type="text" id="titleStep2" name="textTitle" maxLength="35" placeholder={i18n.t('step2.title')+'*'} value={parentState.title} onChange={this.setText} required="required"/>
                </div>
                <div className="texts">
                  <input type="text" name="textSubtitle" maxLength="45" placeholder={i18n.t('step2.subtitle')} value={parentState.subtitle} onChange={this.setText} onKeyDown={this.setSubtitle}/>
                </div>
              </div>
              <div className="texts-row">
                <div className="texts">
                  <input type="text" id="textAuthor" name="textAuthor" maxLength="30" placeholder={i18n.t('step2.author')+'*'} value={parentState.author} onChange={this.setText} onKeyDown={this.setAuthor} required="required" disabled={parentState.specialMapGeneration}/>
                </div>
              </div>
              {parentState.specialMapGeneration && (<div className="texts-row">
                <div className="texts">
                  <input type="text" id="textNipo" name="textNipo" maxLength="12" value={parentState.nipo} placeholder='NIPO* 123-45-678-9' onChange={this.setText} required="required"/>
                </div>
                <div className="texts">
                  <input type="text" id="textISBN" name="textISBN" maxLength="17" value={parentState.isbn} placeholder='ISBN* 978-76-543-2101-2' onChange={this.setText} required="required"/>
                </div>
              </div>)}
              {parentState.specialMapGeneration && (<div className="texts-row">
                <div className="texts">
                  <input type="text" id="textDepositoLegal" name="textDepositoLegal" maxLength="12" placeholder={i18n.t('step2.depLegal')+'* M-25394-2022'} value={parentState.depositoLegal} onChange={this.setText} required="required"/>
                </div>
                <div className="texts">
                  <div className={this.blockColor?'blockedColor':''} style={{position: 'relative'}}>
                    {this.showSpan &&(<span className='placeholderFileInput'>{placeholderFile}</span>)}
                    <input type="file" accept=".jpg,.png,.jpeg" id="imagenCodigoBarras" name="imagenCodigoBarras" onChange={this.handleChangeImageBarras} required={parentState.codigoBarras?false:'required'} style={{width: '100%'}}/>
                    <button className='removeFileClass' onClick={this.clearCodigoBarras}>X</button>
                  </div>
                  <label><Trans i18nKey="step2.codBar">Código de Barras</Trans> (<label className="labelRed">*</label>)</label>
                </div>
              </div>)}
              {parentState.specialMapGeneration && (<div className="texts-row">
                <img src={parentState.codigoBarras} alt="*Barcode*" className="exampleBarcode"></img>
              </div>)}
            </div>

            {/* CAROUSEL */}

            <h2 className="h2Custom"><Trans i18nKey="step2.image">Imagen</Trans></h2>
            <div className="step2wizardPanel3">
            <label id="file-upload-button" className="inputfile generalHelpButton" onClick={this.handleShowCustomImage}>
              <Trans i18nKey="step2.uploadImage">Subir imagen</Trans>
            </label>

            <br/>
            <br/>

            <input id="file-upload" style={{
                display: 'none'
              }} type="file" accept=".jpg,.png,.jpeg" onChange={this.handleChangeImage} encType="multipart/form-data" required="required"/>

            <div id="tui-image-editor" style={{
              height: '710px !important',
              display: 'none'
              }}>
              <canvas></canvas>
            </div>

            <br/>
            <label id="download-tui-image" className="inputfile generalHelpButton" style={{display: 'none'}}>
              <i className="fa fa-cloud-upload"></i>
              <Trans i18nKey="step2.saveImageChanges">Guardar cambios</Trans>
            </label>
            </div>

            <div className='tabs'>
              <hr></hr>
              <div className="tab">
                <input type="radio" id="tab-1" name="aventura" checked={parentState.carouselTabActive === "aventura"
                    ? true
                    : false} onClick={this.setActiveTab} onChange={function(e){}}/>
                <label htmlFor="tab-1"><Trans i18nKey="step2.adventure">Aventura</Trans></label>
                {parentState.carouselTabActive === "aventura" && (<div className="content-carousel" style={{pointerEvents: 'auto'}}>
                  <Carousel cartelaVertical={parentState.verticalCartela} imgs={imgsAventura} imgsMapped={imgsAventuraMapped} onClick={this.setFrontImg}/>
                </div>)}
              </div>
              <div className="tab">
                <input type="radio" id="tab-2" name="cartografia" checked={parentState.carouselTabActive === "cartografia"
                    ? true
                    : false} onClick={this.setActiveTab} onChange={function(e){}}/>
                <label htmlFor="tab-2"><Trans i18nKey="step2.cartography">Cartografía</Trans></label>
                {parentState.carouselTabActive === "cartografia" && (<div className="content-carousel" style={{pointerEvents: 'auto'}}>
                  <Carousel cartelaVertical={parentState.verticalCartela} imgs={imgsCartografia} imgsMapped={imgsCartografiaMapped} onClick={this.setFrontImg}/>
                </div>)}
              </div>
              <div className="tab">
                <input type="radio" id="tab-3" name="ciudades" checked={parentState.carouselTabActive === "ciudades"
                    ? true
                    : false} onClick={this.setActiveTab} onChange={function(e){}}/>
                <label htmlFor="tab-3"><Trans i18nKey="step2.cities">Ciudades</Trans></label>
                {parentState.carouselTabActive === "ciudades" && (<div className="content-carousel" style={{pointerEvents: 'auto'}}>
                  <Carousel cartelaVertical={parentState.verticalCartela} imgs={imgsCiudades} imgsMapped={imgsCiudadesMapped} onClick={this.setFrontImg}/>
                </div>)}
              </div>
              <div className="tab">
                <input type="radio" id="tab-4" name="naturaleza" checked={parentState.carouselTabActive === "naturaleza"
                    ? true
                    : false} onClick={this.setActiveTab} onChange={function(e){}}/>
                <label htmlFor="tab-4"><Trans i18nKey="step2.nature">Naturaleza</Trans></label>
                {parentState.carouselTabActive === "naturaleza" && (<div className="content-carousel" style={{pointerEvents: 'auto'}}>
                  <Carousel cartelaVertical={parentState.verticalCartela} imgs={imgsNaturaleza} imgsMapped={imgsNaturalezaMapped} onClick={this.setFrontImg}/>
                </div>)}
              </div>
              <div className="tab">
                <input type="radio" id="tab-5" name="paisaje" checked={parentState.carouselTabActive === "paisaje"
                    ? true
                    : false} onClick={this.setActiveTab} onChange={function(e){}}/>
                <label htmlFor="tab-5"><Trans i18nKey="step2.landscape">Paisaje</Trans></label>
                {parentState.carouselTabActive === "paisaje" && (<div className="content-carousel" style={{pointerEvents: 'auto'}}>
                  <Carousel cartelaVertical={parentState.verticalCartela} imgs={imgsPaisaje} imgsMapped={imgsPaisajeMapped} onClick={this.setFrontImg}/>
                </div>)}
              </div>
              <div className="tab">
                <input type="radio" id="tab-6" name="varios" checked={parentState.carouselTabActive === "varios"
                    ? true
                    : false} onClick={this.setActiveTab} onChange={function(e){}}/>
                <label htmlFor="tab-6"><Trans i18nKey="step2.others">Varios</Trans></label>
                {parentState.carouselTabActive === "varios" && (<div className="content-carousel" style={{pointerEvents: 'auto'}}>
                  <Carousel cartelaVertical={parentState.verticalCartela} imgs={imgsVarios} imgsMapped={imgsVariosMapped} onClick={this.setFrontImg}/>
                </div>)}
              </div>
            </div>

          </section>
        </div>
      </LayoutAdvanced>
    </React.Fragment>);
  }
}

export default Step2;
